import { apiClient } from "./client";

export type ShiftPattern = {
  id: string;
  organization_id: string;
  practitioner_id: string;
  slot_template_id: string;
  exercise_mode_id: string;
  weekday: number;
  effective_from: string;
  effective_to: string | null;
  name: string | null;
  is_active: boolean;
};

export type ShiftPatternCreatePayload = {
  organization_id: string;
  practitioner_id: string;
  slot_template_id: string;
  exercise_mode_id: string;
  weekday: number;
  effective_from: string;
  effective_to?: string | null;
  name?: string | null;
  is_active?: boolean;
};

export async function listShiftPatterns(params: {
  organization_id?: string;
  practitioner_id?: string;
  active_only?: boolean;
}): Promise<ShiftPattern[]> {
  const { data } = await apiClient.get<ShiftPattern[]>("/api/v1/shift-patterns", { params });
  return data;
}

export async function createShiftPattern(
  p: ShiftPatternCreatePayload,
): Promise<ShiftPattern> {
  const { data } = await apiClient.post<ShiftPattern>("/api/v1/shift-patterns", p);
  return data;
}

export async function patchShiftPattern(
  id: string,
  p: Partial<ShiftPatternCreatePayload>,
): Promise<ShiftPattern> {
  const { data } = await apiClient.patch<ShiftPattern>(`/api/v1/shift-patterns/${id}`, p);
  return data;
}

export async function deleteShiftPattern(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/shift-patterns/${id}`);
}

export type ApplyResult = {
  created: number;
  skipped_conflicts: number;
  patterns_processed: number;
};

export async function applyShiftPatterns(
  organizationId: string,
  year: number,
  month: number,
): Promise<ApplyResult> {
  const { data } = await apiClient.post<ApplyResult>(
    `/api/v1/plannings/${organizationId}/${year}/${month}/apply-patterns`,
  );
  return data;
}
